import * as React from "react";
const SvgFiRrPie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pie_svg__a)">
      <path
        fill="#062147"
        d="M24 14c0-3.624-5.352-8-12-8S0 10.376 0 14a2.946 2.946 0 0 0 2.142 2.887l.532 2.989A5 5 0 0 0 7.6 24h8.8a4.99 4.99 0 0 0 4.923-4.125l.532-2.988A2.95 2.95 0 0 0 24 14m-7.6 8H7.6a3.213 3.213 0 0 1-3.1-3.3A4.015 4.015 0 0 0 9 17.648a4.04 4.04 0 0 0 6 0 4.015 4.015 0 0 0 4.5 1.052 3.21 3.21 0 0 1-3.1 3.3m4.6-7a1.6 1.6 0 0 0-.405.09 1.23 1.23 0 0 0-.75.688 2.016 2.016 0 0 1-3.687 0 1.26 1.26 0 0 0-2.314 0 2 2 0 0 1-3.686 0 1.26 1.26 0 0 0-2.314 0 2.015 2.015 0 0 1-3.687 0 1.24 1.24 0 0 0-.75-.691A6 6 0 0 0 3 15a.915.915 0 0 1-1-1c0-2.369 4.48-6 10-6 5.522 0 10 3.631 10 5.988A.92.92 0 0 1 21 15M11 3V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0m4 0V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0M7 3V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0m3.986 7.65a5.4 5.4 0 0 1-.753 1.967 1.308 1.308 0 0 1-1.85-1.85 5.4 5.4 0 0 1 1.968-.752.526.526 0 0 1 .634.635m4.631.117a1.308 1.308 0 0 1-1.85 1.85 5.4 5.4 0 0 1-.751-1.967.526.526 0 0 1 .634-.635c.7.12 1.367.375 1.967.752"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pie_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPie;
